module.exports = __webpack_public_path__ + "img/productName.6524e3d3.jpg";